// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"48":"1a520815","674":"4457a337","941":"aea36148"}[chunkId] + ".chunk.js";
};